export const getDisplayAdministrationName = (
  administrationName?: string,
  administrationNameHungarian?: string
): string => {
  let result = administrationName || "";
  if (administrationNameHungarian) {
    result += ` | ${administrationNameHungarian}`;
  }
  return result;
};
